import { render } from "./DueDateDashboard.vue?vue&type=template&id=0d60ea14&scoped=true"
import script from "./DueDateDashboard.vue?vue&type=script&lang=js"
export * from "./DueDateDashboard.vue?vue&type=script&lang=js"

import "./DueDateDashboard.vue?vue&type=style&index=0&id=0d60ea14&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d60ea14"]])

export default __exports__